import {fnGetCodeVal} from '~/utils/admin-common'

export const state = () => ({
  apiUrl: {
    pamReqResultUrl: '/api/pm/pams-req/result'
  },
  resultInquiryList: [],
  resultInquiryListFilter: [],
  resultApplyRuleList: [],
  deviceSelected: null,
  resultApplyFirewallList: [],
  resultPoliciesHistory: [],
  resultErrorMessage: null
})

export const mutations = {
  mutResultInquiry (state, payload) {
    state.resultInquiryList = payload.map(item => {
      item.pams_req_status_type_name = fnGetCodeVal('pams_req_status_type', item.pams_req_status_type)
      item.pams_req_type_name = fnGetCodeVal('pams_req_type', item.pams_req_type)
      item.pams_fix_rule_verify_type_name = fnGetCodeVal('pams_fix_rule_verify_type', item.pams_fix_rule_verify_type)
      return item
    })
    state.resultInquiryListFilter = state.resultInquiryList
  },
  mutResultApplyRuleList (state, payload) {
    state.resultApplyRuleList = payload.filter((item, index) => {
      item.idx = (index + 1)
      item.pams_fix_rule_type_name = fnGetCodeVal('pams_fix_rule_type', item.pams_fix_rule_type)
      item.pams_fix_rule_verify_type_name = fnGetCodeVal('pams_fix_rule_verify_type', item.pams_fix_rule_verify_type)
      item.pams_fix_rule_prtc_name = fnGetCodeVal('net_srv_prtc', item.pams_fix_rule_prtc)
      return item
    })
  },
  mutResultApplyFirewallList (state, payload) {
    state.deviceSelected = payload.device_id
    state.resultApplyFirewallList = payload.list.filter((item, index) => {
      item.idx = (index + 1)
      item.pams_fix_rule_prtc_name = fnGetCodeVal('net_srv_prtc', item.pams_fix_rule_prtc)
      item.pams_fix_rule_type_name = fnGetCodeVal('pams_fix_rule_type', item.pams_fix_rule_type)
      return item
    })
  },
  mutResultPoliciesHistory (state, payload) {
    state.resultPoliciesHistory = payload
  },
  mutationErrorMessage (state, payload) {
    state.resultErrorMessage = payload
  },

  clearResultApplyRuleList (state) {
    state.resultApplyRuleList = []
  },
  clearResultApplyFirewallList (state) {
    state.deviceSelected = null
    state.resultApplyFirewallList = []
  },
  clearResultPoliciesHistory (state) {
    state.resultPoliciesHistory = []
  }
}
export const actions = {
  // 결과조회
  async acsResultInquiry ({commit, state}) {
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamReqResultUrl}/result`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutResultInquiry', res.result)
      } else {
        commit('mutResultInquiry', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // R_17 - p57: 확정 정책별
  async acsResultApplyRuleList ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    commit('clearResultApplyRuleList')
    try {
      res = await this.$axios.$get(`${state.apiUrl.pamReqResultUrl}/${payload.pams_req_id}`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutResultApplyRuleList', res.result)
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 결과 조회 > 적용 내역 > 확정 정책별 조회 59p
  async acsResultApplyFirewallList ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    commit('clearResultApplyFirewallList')
    try {
      res = await this.$axios.$get(`${state.apiUrl.pamReqResultUrl}/${payload.pams_req_id}/${payload.device_id}`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        const resq = {
          device_id: payload.device_id,
          list: res.result
        }
        commit('mutResultApplyFirewallList', resq)
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  async acsResultPoliciesHistory ({commit, state}, payload) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.pamReqResultUrl}/hstry/${payload.pams_req_id}`)
      if (res.code === 'ok') {
        commit('mutResultPoliciesHistory', res.result[0])
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  }
}
export const getters = {}
export const strict = false
